module.exports = __webpack_public_path__ + "img/tab3.1b14b213.png";